import { render, staticRenderFns } from "./PositionCard.vue?vue&type=template&id=48591460&scoped=true&"
import script from "./PositionCard.vue?vue&type=script&lang=ts&"
export * from "./PositionCard.vue?vue&type=script&lang=ts&"
import style0 from "./PositionCard.vue?vue&type=style&index=0&id=48591460&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48591460",
  null
  
)

export default component.exports